<template lang="pug">
.not-found-container(:class="$mq")
  .layout
    .four 4
    img.logo(src="@/assets/img/logo-mini-light@2x.png")
    .four 4
    .not-found not found
  router-link(to="/").back-link(:class="$mq") retourner sur moonlyapp.com
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="scss" scoped>
@use '@/styles/colors';
@use '@/styles/text';

.not-found-container {
  width: 100%;
  min-height: 100vh;
  min-height: 100vh;
  background-image: linear-gradient(100deg, colors.$intense-purple, colors.$light-purple);

  display: grid;
  justify-content: center;
  align-content: center;
  justify-items: center;
  grid-template-rows: auto auto;
  row-gap: 50px;

  color: white;
}

.layout {
  max-width: 500px;
  height: 300px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 2fr 1fr;
  justify-items: center;
  align-items: center;

  .four {
    font-size: 200px;
    font-weight: 700;
    line-height: 200px;
  }

  .logo {
    margin-top: -6%;
    width: 100%;
    height: auto;
  }

  .not-found {
    font-size: 130px;
    line-height: 130px;
    $shadow: drop-shadow(5px 5px 10px rgba(black, 0.1));
    -webkit-filter: $shadow;
    filter: $shadow;
    font-weight: 700;
    grid-column: 1 / 4;
    white-space: nowrap;
  }
}

.not-found-container.phone {
  row-gap: 20px;
  .layout {
    max-width: 300px;
    height: 200px;

    .four {
      font-size: 120px;
      line-height: 120px;
    }

    .not-found {
      font-size: 60px;
      line-height: 60px;
    }
  }
}

.back-link {
  @include text.tiny;
  text-decoration: underline;
  cursor: pointer;
  color: white;
}
</style>
